import React from 'react';

const InputLabel = ({
  children,
  variant = 'default',
  required = false,
  htmlFor,
  className = ''
}) => (
  <label
    htmlFor={htmlFor}
    className={`
      text-slate-500 text-sm block tracking-wide
      ${variant === 'header' ? 'mb-1.5 pt-0.5' : 'mb-2'}
      ${className}
    `}
  >
    {children}
  </label>
);

export default InputLabel;